import { Component, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import {
  ContentTopTasksButtonComponent,
  ContentTopTasksSectionComponent,
} from '@content/ui/content-top-tasks';
import {
  computedContentSectionId,
  computedContentSectionTheme,
  ContentSectionComponent,
} from '@core/content-section';

@Component({
  selector: 'wl-content-three-top-tasks-container',
  standalone: true,
  templateUrl: './content-three-top-tasks-container.component.html',
  imports: [
    ContentTopTasksButtonComponent,
    ContentTopTasksSectionComponent,
    ContentSectionComponent,
  ],
})
export class ContentThreeTopTasksContainerComponent {
  readonly rendering = input.required<InnogyComponentRendering>();
  readonly id = computedContentSectionId(this.rendering);
  readonly theme = computedContentSectionTheme(this.rendering);
}
